const pullRequestDashboardHostname = /^dashboard-\d+\.pr\.eye-able\.com$/;

export function isPullRequestDashboardHostname(hostname: string): boolean {
  return pullRequestDashboardHostname.test(hostname);
}
